import { IJudgmentCourtLevel } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentCourtLevel';
import { IKnmJudgmentCourtLevelSelectOption } from '../interfaces/IKnmJudgmentCourtLevelSelectOption';

export const createJudgmentCourtLevelSelectOption = (
  erknmJudgmentCourtLevel: IJudgmentCourtLevel,
): IKnmJudgmentCourtLevelSelectOption => ({
  ...erknmJudgmentCourtLevel,
  label: erknmJudgmentCourtLevel.name,
  value: erknmJudgmentCourtLevel.code,
});
